import {isMobile} from "mobile-device-detect";
import router from "@/router";
import _ from "lodash";
import {ActionContext} from "vuex";
import {IAppConfirm} from "@/modules/Popup/interfaces/app-confirm-state.interface";
import {IAppState} from "@/interfaces/app-state.interface";
import {IAppErrorPopup} from "@/modules/Popup/interfaces/app-error-popup.interface";

type ErrorActionContext = ActionContext<IAppErrorPopup.IState, IAppState>;
export const ErrorStore: ErrorActionContext = {
  // @ts-ignore
  namespaced: true,

  state: {
    textId: '',
    payload: null,
    countSidesToAdd: null,
    isVisible: false,
    responseData: {},
    requestData: {},
  },

  mutations: {
    open(state: IAppErrorPopup.IState, { textId, payload, responseData, requestData, countSidesToAdd }: { textId: string, payload: any, responseData?: any, requestData?: any, countSidesToAdd?: any }) {
      state.textId = textId;
      state.payload = payload;
      state.countSidesToAdd = countSidesToAdd;
      state.isVisible = true;
      state.responseData = responseData;
      state.requestData = requestData;
    },

    close(state: IAppErrorPopup.IState) {
      state.textId = '';
      state.payload = null;
      state.isVisible = false;
    }
  },

  actions: {
    open({ rootState, commit }: ErrorActionContext, { textId, payload, responseData, requestData, countSidesToAdd }: { textId: string, payload?: any, responseData?: any, requestData?: any, countSidesToAdd?: any }) {
      commit('open', {
        textId,
        payload: payload !== undefined ? payload : null,
        countSidesToAdd: countSidesToAdd !== undefined ? countSidesToAdd : null,
        responseData,
        requestData,
      });

      if (isMobile) {
        router.push({name: rootState.route.name, query: {...rootState.route.query, dialog: 'error',}});
      }
    },

    close({ commit, rootState }: ErrorActionContext) {
      commit('close');

      if (isMobile) {
        const query = _.clone(rootState.route.query);
        if (query.dialog) {
          router.go(-1);
        }
      }
    },
  },
};
